<template>
  <div>
    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark shadow static-top headerbar " style="padding-right:0px;min-height: 69px;padding:0px; box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.45) !important;z-index:999">
      <router-link tag="a" class="navbar-brand" href="#" :to="'Dashboard'" style="padding-left:6px">
        <img src="./assets/img/deskalo.png" v-if="isMobile == false" class="img img-responsive" style="margin-top:-6px;margin-right:6px;max-height:59px">
        <span v-else><strong><i class="fal fa-home-lg-alt"></i> Deskalo</strong></span>
      </router-link>     
  <div class="collapse navbar-collapse "></div>
      <div>
        <a v-on:click="openPopUpSceltaSocio()" class="nav-link" style="cursor:pointer" v-show="isMobile == false && DESKALO_SOCIO_SELEZIONATO.ID_SOCIO > 0">
          <div style="float:left" >
            <img href="#" :src="'https://assosprint.it/app/IMG/LOGHI/'+ getNegozio(DESKALO_SOCIO_SELEZIONATO.ID_NEGOZIO).URL_LOGO"  style="width:42px;height: 42px;;margin-right:10px" class="rounded-circle">
          </div>
          <div style="float:left" >
              <span style="color:#fff;"><strong>{{getSocio(DESKALO_SOCIO_SELEZIONATO.ID_SOCIO,DESKALO_SOCIO_SELEZIONATO.ID_NEGOZIO).NOME}} {{getSocio(DESKALO_SOCIO_SELEZIONATO.ID_SOCIO,DESKALO_SOCIO_SELEZIONATO.ID_NEGOZIO).COGNOME}} (Cambia socio)</strong><br/>{{getNegozio(DESKALO_SOCIO_SELEZIONATO.ID_NEGOZIO).ALIAS}}</span>
          </div>
        </a>

         <a v-on:click="openPopUpSceltaSocio()" class="nav-link" style="cursor:pointer;padding-top:0px" v-show="isMobile == true && DESKALO_SOCIO_SELEZIONATO.ID_SOCIO > 0">
          <div style="float:left;text-align:right">
              <span style="color:#fff;font-size:12px"><strong>{{getSocio(DESKALO_SOCIO_SELEZIONATO.ID_SOCIO,DESKALO_SOCIO_SELEZIONATO.ID_NEGOZIO).NOME}}
                                              {{getSocio(DESKALO_SOCIO_SELEZIONATO.ID_SOCIO,DESKALO_SOCIO_SELEZIONATO.ID_NEGOZIO).COGNOME}}</strong><br/>{{getNegozio(DESKALO_SOCIO_SELEZIONATO.ID_NEGOZIO).ALIAS}}</span>
          </div>
        </a>

          

      </div>
      <div class="topbar-divider d-none d-md-block " v-if="utente.ID_UTENTE > 0"></div>

      <ul class="navbar-nav ml-auto userinfo " style="" >
        <li class="nav-item dropdown no-arrow">
          <a class="nav-link dropdown-toggle"  v-if="utente.ID_UTENTE > 0" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="fa-stack">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="fas fa-user fa-stack-1x fa-inverse"></i>
            </span>
            <!--
            <img class="img-profile rounded-circle" :src="'CORE/UPLOAD/AVATAR/'+ utente.URL_AVATAR" style="width:37px;height:37px">-->
          </a>
          <!-- Dropdown - User Information -->
          <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
            <a class="dropdown-item" href="#" v-on:click="modificaProfilo()"  >
              <i class="fas fa-user fa-sm fa-fw mr-2 "></i>
              Profilo
            </a>
            <a class="dropdown-item" href="#" v-on:click="modificaPassword()">
              <i class="fas fa-cogs fa-sm fa-fw mr-2 "></i>
              Password
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#"   v-on:click="logout()" >
              <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 "></i>
              Logout
            </a>
          </div>
        </li>
      </ul>
    </nav>
    <div id="wrapper">
      <div id="content-wrapper" class="d-flex flex-column" style="margin-top:69px;padding-top:5px" >
          <div id="content" >
            <div class="container-fluid"  v-if="isMobile == false" id="kt_vue_content_parent" >
                <router-view/>
            </div>
            <div class="container-fluid" v-else id="kt_vue_content_parent" style="padding-left: 0.2rem ;padding-right: 0.2rem;">
                <router-view/>
            </div>
          </div>
      </div>

      <div class="modal fade" id="popUpConfirm"  role="dialog"  aria-modal="true" >
          <div class="modal-dialog"  >
              <div class="modal-content" >
                  <div class="modal-header modal-header-info">
                      <h5 class="modal-title">{{alertConfirm.TITLE}}</h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-2" style="margin-top:10px;font-size:40px">
                            <i class="fas " v-bind:class="alertConfirm.ICON"></i>
                        </div>
                        <div class="col-md-10 align-items-center" style="margin-top:10px">
                            <div v-html="alertConfirm.MESSAGE"></div>
                        </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-danger" v-on:click="alertConfirm.KOHandler()"><i class="fa fa-times fa-fw"></i>{{alertConfirm.KO}}</button>
                      <button type="button" class="btn btn-success" v-on:click="alertConfirm.OKHandler()"><i class="fa fa-check fa-fw"></i>{{alertConfirm.OK}}</button>
                  </div>
              </div>
          </div>
      </div>

      <div class="modal fade" id="popUpModificaPassword"  role="dialog"  aria-modal="true" >
            <div class="modal-dialog"  >
                <div class="modal-content" >
                    <div class="modal-header modal-header-info">
                        <h5 class="modal-title">Modifica Password</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                    <div class="modal-body">
                      <form  autocomplete="off">   
                        <div class="form-group" >
                            <label>Vecchia password</label><br/>
                            <input class="form-control form-control-sm"  autocomplete="off"  placeholder="Vecchia password" type="password" v-model="passwordUtente.VECCHIA_PASSWORD">
                        </div> 
                        <div class="form-group" >
                            <label>Nuova password</label><br/>
                            <input class="form-control form-control-sm"  autocomplete="off"  placeholder="Nuova password" type="password" v-model="passwordUtente.PASSWORD">
                        </div> 
                        <div class="form-group" >
                            <label>Conferma nuova password</label><br/>
                            <input class="form-control form-control-sm"  autocomplete="off"  placeholder="Conferma nuova password" type="password" v-model="passwordUtente.CONFERMA_PASSWORD">
                        </div>  
                      </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" data-dismiss="modal"><i class="fa fa-times fa-fw"></i>Annulla</button>
                        <button type="button" class="btn btn-success" v-on:click="doModificaPassword()"><i class="fa fa-check fa-fw"></i>Ok</button>
                    </div>
                </div>
            </div>
      </div>


    </div>  

     <div class="modal fade" id="popUpAlertStandard"  role="dialog"  aria-modal="true" >
            <div class="modal-dialog"  >
                <div class="modal-content" >
                    <div class="modal-header modal-header-info">
                        <h5 class="modal-title">{{alertStd.TITLE}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-2" style="margin-top:10px;font-size:40px">
                              <i v-bind:class="alertStd.ICON"></i>
                          </div>
                          <div class="col-md-10 align-items-center" style="margin-top:10px">
                              <div v-html="alertStd.MESSAGE"></div>
                          </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" v-on:click="alertStd.OKHandler()"><i class="fa fa-check fa-fw"></i>{{alertStd.OK}}</button>
                    </div>
                </div>
            </div>
        </div>


    <div class="modal fade" id="popUpSoci"  role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="max-width:574px"  >
            <div class="modal-content" >
                <div class="modal-header modal-header-info">
                    <h5 class="modal-title">Seleziona socio</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="modal-body">
                    <ul class="list-group">
                        <template v-for="negozio in arrayNegozi" v-bind:key="negozio.ID_NEGOZIO">
                          <li class="list-group-item" style="cursor:pointer" v-for="socio in negozio.ARRAY_SOCI" v-bind:key="socio.ID_SOCIO"  v-on:click="setSocio(socio,negozio)">
                              <div class="col-3" style="text-align:center" v-show="isMobile == false">
                                  <img :src="'https://assosprint.it/app/IMG/LOGHI/'+negozio.URL_LOGO" class="img-responsive" style="max-width:120px;max-height:55px;margin:0 auto">
                              </div>
                              <div v-bind:class="{'col-9':isMobile==false,'col-12':isMobile == true}">
                                  <strong>{{socio.NOME}} {{socio.COGNOME}}</strong><br/><span style="font-size:16px">{{negozio.ALIAS}}</span>
                              </div>
                          </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </div>


  </div>
</template>


<script>

export default {
    name: 'App',
    data:function(){
        return {
          alertConfirm:{
            MESSAGE:"prova"
          },
          zindex:1100,
          title:'Dashboard',
          icon:'fa-home',
          passwordUtente:{},
          isAdmin : false,
          alertStd:{},
          utente:{},
          arrayMenu: new Array(),
          arrayStagioni : new Array(),
          idStagioneCorrente:0,
          idMobile:false,
          previousRoute:"/",
          arrayNegozi:new Array(),
          DESKALO_SOCIO_SELEZIONATO:{}
        }
    },
    methods : {
      logout : function(){
        global.utils.ajax('core/logout',{}, (response) => {
          this.$root.utente = {};
          global.utils.deleteCookie("session_token");
          global.router.push("Login");
          this.arrayMenu = new Array();
        });
      },
      isCurrent : function(menu){
        var stile = {};
        stile['color'] = "#fff";
        stile['border-bottom'] = "2px solid #5a5c69";
        stile['font-weight'] = "bold";
        if (menu.ROUTE == this.currentRouteName || (this.mainMenuActive == 0 && menu.ROUTE == this.previousRoute)){
          stile['background'] = menu.COLORE;
          stile['border'] = "2px solid #fff" ;

         // stile['border-bottom'] = "2px solid " + menu.COLORE;
        }
        else{
          //stile['background'] = menu.COLORE + "20";
          stile['border'] = "2px solid rgba(0,0,0,0)" ;
        }
        return stile;
      },
      confirm : function(alertConfirm){
        this.alertConfirm = alertConfirm;
        var modal = global.$('#popUpConfirm');
        modal.modal('show');
      },
      setHeader : function(_title,_icon){
        this.title = _title;
        this.icon = _icon;
      },
      back : function(){
        global.router.go(-1);
      },
      modificaPassword : function(){
        var modal = global.$('#popUpModificaPassword');
        modal.modal('show');
      },
      modificaStagioneCorrente : function(){
        var modal = global.$('#popUpModificaStagione');
        modal.modal('show');
      },
      doModificaStagioneCorrente : function(){
        var modal = global.$('#popUpModificaStagione');
        modal.modal('hide');
        global.utils.ajax('as/stagionecorrente/update',{ID_STAGIONE:this.idStagioneCorrente}, (response,status) => {
          if (response.esito == 0){
            global.utils.alert.success("Operazione correttamente eseguita");
            this.startHandler();
          }
        });
      },
      modificaProfilo : function(){
        global.router.push("Profilo");
      },
      doModificaPassword : function(){
        //)7.HRK=L3M!xiyRq,vZ
        var modal = global.$('#popUpModificaPassword');
        modal.modal('hide');
        global.utils.ajax('core/utente/password/update',this.passwordUtente, (response,status) => {
          if (response.esito == 0){
            global.utils.alert.success("Operazione correttamente eseguita");
          }
        });
      },
      getDataColor : function(route){
        return route.DESCRIZIONE;
      },
      openPopUpLogin : function(){
          var modal = global.$('#popUpRecoveryLogin');
          modal.modal('show');
      },
      checkMobile : function(route){
        if (this.isMobile == false){
          return true;
        }
        else{
          if (route.ROUTE == '/Soci' || route.ROUTE == '/attivita' || route.ROUTE == '/abbonamenti'){
            return true;
          }
        }
        return false;
      },
      startHandler : function(){
        this.arrayMenu = new Array();
        global.router.push("Start");
        //1.VERIFICO ESISTENZA TOKEN
        console.log("*** AVVIO APPLICAZIONE ***");
        var token = global.utils.getCookie("session_token");
        //SE E' PRESENTE IL TOKEN, PROVIAMO A RECUPERARE L'Utente
        if (token != "" && token != undefined && token != "undefined"){
            global.utils.SESSION_TOKEN = token;
            global.utils.ajax('core/logged',{}, (response) => {
              if (response.esito == 0 && response.data.UTENTE.ID_UTENTE > 0){
                this.utente = response.data.UTENTE;
                for (var i = 0 ; i < this.utente.funzionalita.length ; i++){
                  if (this.utente.funzionalita[i].FK_ID_ITEM > 0){
                    this.arrayMenu.push(this.utente.funzionalita[i].menuItem);
                  }
                }
                global.router.push("Dashboard");
              }
              else{
                global.router.push("Login");
                this.arrayMenu = new Array();
              }
            });
        }
        else{
          this.arrayMenu = new Array();
          global.router.push("Login");
        }
      },
      openPopUpSceltaSocio:function(){
          var modal = global.$('#popUpSoci');
          modal.modal('show');
      },
      setSocio:function(socio, negozio){
        console.log(socio, negozio);
        var params = {ID_SOCIO:socio.ID_SOCIO,ID_NEGOZIO:negozio.ID_NEGOZIO};
        global.utils.ajax('deskalo/setsocio',params, (response) => {
          if (response.esito == 0){
            var modal = global.$('#popUpSoci');
            modal.modal('hide'); 
            this.startHandler(); 
          }
        }); 
      },
      getSocio:function(idSocio,idNegozio){
        for (var i = 0 ; i < this.arrayNegozi.length ; i++){
          if (this.arrayNegozi[i].ID_NEGOZIO == idNegozio){
            for (var j = 0 ; j < this.arrayNegozi[i].ARRAY_SOCI.length ; j++){
              if (this.arrayNegozi[i].ARRAY_SOCI[j].ID_SOCIO == idSocio){
                return this.arrayNegozi[i].ARRAY_SOCI[j];
              }
            }
          }
        }
        return {};
      },
      getNegozio:function(idNegozio){
        for (var i = 0 ; i < this.arrayNegozi.length ; i++){
          if (this.arrayNegozi[i].ID_NEGOZIO == idNegozio){
            return this.arrayNegozi[i];
          }
        }
        return {};
      }
    },
    computed : {
      currentRouteName() {
          return this.$route.path;
      },
      mainMenuActive(){
        for (var i = 0 ; i < this.arrayMenu.length ; i++){
          if (this.arrayMenu[i].ROUTE == this.currentRouteName){
            return 1;
          }
        }
        return 0;
      }
    },
    created : function(){
        var ua = navigator.userAgent;
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua))
            this.isMobile = true;
        else
            this.isMobile = false;

        //global.utils.BASE_API = "http://localhost/dryland_2/CORE/SERVER/API/"; //process.env.VUE_APP_API_URL;
        global.utils.BASE_API = process.env.VUE_APP_API_URL;

        this.startHandler();
        setTimeout(() => {
            $('.modal').on('show.bs.modal',  (e) => {
                setTimeout(() => {
                    this.zindex++;
                    $('.modal-backdrop').last().css("z-index",this.zindex);
                    this.zindex++;
                    $('.modal.fade.show').last().css("z-index",this.zindex); 
                }, 200);
            });                    
        }, 400);
        /*
        global.utils.ajax2('core/login',{USERNAME:'nadia.tirotta',PASSWORD:'nadia'}, (response) => {
          global.utils.SESSION_TOKEN = response.data.SESSION_TOKEN;
          global.utils.ajax2('core/logged',{USERNAME:'nadia.tirotta',PASSWORD:'nadia'}, () => {
            global.utils.ajax2('core/home',{USERNAME:'nadia.tirotta',PASSWORD:'nadia'}, () => {
              global.router.push("/soci"); 
            }); 
          });        
        });*/


        //this.startHandler();
    },
    
    watch:{
        $route (valore,valoreOld){
          console.log(valore.path,valoreOld.path);
          this.previousRoute = valoreOld.path;
          if (valore.path == "/Pagamento"){
            this.previousRoute = "/pagamenti";
          }
          $('#kt_vue_content_parent').hide().fadeIn(600);
          setTimeout(() => {
            global.$('form').submit(function(event){
                event.preventDefault();
                event.stopPropagation();
                return false;
            });
            $('.modal').on('show.bs.modal',  (e) => {
                setTimeout(() => {
                    this.zindex++;
                    $('.modal-backdrop').last().css("z-index",this.zindex);
                    this.zindex++;
                    $('.modal.fade.show').last().css("z-index",this.zindex); 

                    global.$('form').submit(function(event){
                        event.preventDefault();
                        event.stopPropagation();
                        return false;
                    });
                }, 200);
            });      
            global.utils.resizeContent();
          }, 300);
        }
    }
}
</script>


